export enum RegisterError {
    EmailAlreadyExist = 1
}